// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"2feb1650","583":"ac489afe","833":"4cab0693","910":"28e6b283"}[chunkId] + ".chunk.js";
};